var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObjectFence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,30 L52,30 L52,30 C52.5522847,30 53,30.4477153 53,31 L53,31 L53,31 C53,31.5522847 52.5522847,32 52,32 L21,32 L21,32 C20.4477153,32 20,31.5522847 20,31 L20,31 L20,31 C20,30.4477153 20.4477153,30 21,30 Z",
    className: "fillColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,15 L21,15 L21,15 C21.5522847,15 22,15.4477153 22,16 L22,16 L22,16 C22,16.5522847 21.5522847,17 21,17 L1,17 L1,17 C0.44771525,17 6.76353751e-17,16.5522847 0,16 L0,16 L0,16 C-6.76353751e-17,15.4477153 0.44771525,15 1,15 Z",
    className: "fillColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,9 L25,9 L25,9 C25.5522847,9 26,9.44771525 26,10 L26,10 L26,10 C26,10.5522847 25.5522847,11 25,11 L1,11 L1,11 C0.44771525,11 6.76353751e-17,10.5522847 0,10 L0,10 L0,10 C-6.76353751e-17,9.44771525 0.44771525,9 1,9 Z",
    className: "fillColor"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fillColor",
    x: 24,
    y: 36,
    width: 29,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fillColor",
    x: 28,
    y: 42,
    width: 25,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fillColor",
    x: 30,
    y: 48,
    width: 23,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,38 C9.98717542,38.9168269 14.6538421,43.5834936 15,52",
    className: "strokeColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,46 C4.85164661,46.3929258 6.85164661,48.3929258 7,52",
    className: "strokeColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,30 C15.1227042,31.440728 22.4560376,38.7740613 23,52",
    className: "strokeColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fillColor",
    x: 38,
    y: 13,
    width: 2,
    height: 9,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,23 L35,23 L35.8695048,22.5652476 L35.8695048,22.5652476 C37.8401973,21.5799014 40.1598027,21.5799014 42.1304952,22.5652476 L43,23 L52,23",
    className: "strokeColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,16.9999902 C52.5409966,17.0149319 42.9660547,-0.085705234 39,0.000323505745 C35.0339453,0.0863522455 25.4590034,16.9850485 39,16.9999902 Z",
    className: "strokeColor",
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectFence);
export default __webpack_public_path__ + "static/media/object-fence.96d715d8.svg";
export { ForwardRef as ReactComponent };